import { Reveal } from "@/components/motion";
import { Eyebrow, CTA } from "@/components/kit";

// Banner reutilizable con la ilustración del dúo (Anto & Bella) — presente en todas las páginas
export const DuoBanner = ({
  image,
  imgSide = "right",
  tint = "#A8E6CF",
  eyebrow = "Anto & Bella",
  eyebrowColor = "#FF8A80",
  title,
  text,
  cta,
  alt = false,
}) => {
  const Img = (
    <div className="relative flex items-end justify-center">
      <div
        className="absolute bottom-6 h-56 w-56 rounded-full blur-3xl sm:h-72 sm:w-72"
        style={{ backgroundColor: tint + "88" }}
      />
      <img
        src={image}
        alt="Anto y Bella juntas"
        className="relative z-10 w-full max-w-md drop-shadow-[0_20px_40px_rgba(0,0,0,0.12)]"
      />
    </div>
  );

  return (
    <section className={`px-5 sm:px-8 lg:px-12 py-16 sm:py-20 ${alt ? "bg-mist" : "bg-cream"}`}>
      <div className="mx-auto max-w-7xl">
        <Reveal className="overflow-hidden rounded-[2.5rem] bg-white p-8 sm:p-12 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
          <div className="grid items-center gap-8 lg:grid-cols-2">
            {imgSide === "left" && <div className="order-1">{Img}</div>}
            <div className={imgSide === "left" ? "order-2" : "order-1"}>
              <Eyebrow color={eyebrowColor}>{eyebrow}</Eyebrow>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-[0.95] tracking-tighter text-ink">
                {title}
              </h2>
              {text && (
                <p className="mt-5 max-w-lg text-lg text-ink/70 leading-relaxed">{text}</p>
              )}
              {cta && (
                <CTA to={cta.to} variant={cta.variant || "coral"} className="mt-7">
                  {cta.label}
                </CTA>
              )}
            </div>
            {imgSide !== "left" && <div className="order-2">{Img}</div>}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
